import { Link } from 'react-router-dom';
import { Mail, MapPin, ArrowUpRight, Phone } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="main-footer">
      {/* Main Footer */}
      <div className="container-main py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_ba4b6351-8570-4d37-8ada-e860f15e5a88/artifacts/1g1y2f72_BE56DF6F-9346-439E-AE51-DFDCCEBB5116.png"
              alt="DAAS Global"
              className="h-16 w-auto mb-6 brightness-[1.8]"
            />
            <p className="text-white/70 text-sm leading-relaxed max-w-md mb-6">
              International Student Education Consultancy<br />
              A subsidiary of DAAS Limited
            </p>
            <p className="text-[var(--secondary)] text-sm font-medium italic">
              "Process-driven, ethical, experience-backed education consultancy"
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="footer-link flex items-center gap-2 group" data-testid="footer-link-home">
                Our Services
                <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
              <Link to="/about" className="footer-link flex items-center gap-2 group" data-testid="footer-link-about">
                About
                <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
              <Link to="/careers" className="footer-link flex items-center gap-2 group" data-testid="footer-link-careers">
                Work Culture & Careers
                <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
              <Link to="/contact" className="footer-link flex items-center gap-2 group" data-testid="footer-link-contact">
                Contact
                <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-bold uppercase tracking-widest mb-6">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[var(--secondary)] mt-1 flex-shrink-0" />
                <span className="text-white/70 text-sm leading-relaxed">
                  Rupayan Shopping Square (4th Floor),<br />
                  Plot No. 02, Sayem Sobhan Anvir Road,<br />
                  Bashundhara R/A, Dhaka-1229<br />
                  <span className="text-white/90 font-semibold">Dhaka, Bangladesh</span>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[var(--secondary)] flex-shrink-0" />
                <a
                  href="https://wa.me/8801338770055"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 text-sm hover:text-[var(--secondary)] transition-colors"
                  data-testid="footer-phone"
                >
                  +880 1338-770055
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[var(--secondary)] flex-shrink-0" />
                <a
                  href="mailto:daasglobalsub@gmail.com"
                  className="text-white/70 text-sm hover:text-[var(--secondary)] transition-colors"
                  data-testid="footer-email"
                >
                  daasglobalsub@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="border-t border-white/10" data-testid="footer-disclaimer">
        <div className="container-main py-8">
          <p className="text-white/50 text-xs leading-relaxed text-center max-w-4xl mx-auto">
            <strong className="text-white/70">Legal Disclaimer:</strong> DAAS Global provides advisory and administrative support only. 
            Admissions and visa decisions are made solely by educational institutions and immigration authorities. 
            DAAS Global does not guarantee outcomes.
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="container-main py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-xs">
              &copy; {currentYear} DAAS Global. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy-policy" className="text-white/40 text-xs hover:text-white/70 transition-colors" data-testid="footer-privacy">
                Privacy Policy
              </Link>
              <p className="text-white/40 text-xs">
                A subsidiary of DAAS Limited
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
